import { toPlatePlugin } from '@udecode/plate/react';

import { BaseShortcutInputPlugin,BaseShortcutPlugin } from '../lib';

export const ShortcutPlugin = toPlatePlugin(BaseShortcutPlugin);
export const ShortcutInputPlugin = toPlatePlugin(BaseShortcutInputPlugin);
